import { useTranslation } from "react-i18next";
import TableCell from "../../common/table/tableCell";
import ButtonSubmit from "../../common/buttonSubmit";
import TableCellButton from "../../common/table/TableCellButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Row = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { citizens } = useSelector((state: any) => state);
  const { editCitizen } = citizens;

  const handleRedirect = () => {
    navigate(`/survey-form/${props.survey._id}`, {
      state: {
        urlHistory: `/enrollment/citizen-detail/${editCitizen._id}`,
        citizenDetail: {
          citizenId: editCitizen._id,
          name: editCitizen.name,
          surname: editCitizen.surname,
          fiscalcode: editCitizen.crm.extraFields.fiscalcode.value,
        },
      },
    });
  };
  return (
    <tr className="tablePharmacies">
      <TableCell label={props.survey.campaign} class="column-width" />
      <TableCell label={props.survey.name} />
      <TableCellButton>
        <ButtonSubmit
          spinner={false}
          textButton={t("conduct-survey")}
          handleChange={() => handleRedirect()}
        />
      </TableCellButton>
    </tr>
  );
};

export default Row;
